"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataLevel = exports.respData = exports.GetLevel = void 0;
let dataLevel;
function respData(data) {
    exports.dataLevel = dataLevel = data;
    return dataLevel;
}
exports.respData = respData;
function GetLevel(url) {
    return __awaiter(this, void 0, void 0, function* () {
        return fetch(url, { method: 'GET' })
            .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error, status = ${response.status}`);
            }
            return response.json();
        })
            .then((data) => respData(data.rounds));
    });
}
exports.GetLevel = GetLevel;
